import request from '@/utils/request'

// 实时人流数据
export function peopleNum (params) {
  return request({
    url: '/v1/flow/passenger/realtime',
    method: 'post',
    params
  })
}

// 基础设施分类
export function facilityCategory (params) {
  return request({
    url: '/v1/device/category/list',
    method: 'get',
    params
  })
}

// 获取摄像头code
export function getCamerCode (params) {
  return request({
    url: '/biz/artemis/getCameraList',
    method: 'get',
    params
  })
}

// 获取监控url
export function getVideoUrl (code) {
  return request({
    url: `/biz/artemis/getCameraUrl/${code}`,
    method: 'get'
  })
}

// 设备实时告警
export function getAlarmTotal (params) {
  return request({
    url: '/biz/alarmInfo/getAlarmTotal',
    method: 'get',
    params
  })
}

// 设备统计数量
export function getDeviceTotal (params) {
  return request({
    url: '/v1/device/info/health',
    method: 'get',
    params
  })
}

// 设备类型
export function getDeviceType (params) {
  return request({
    url: '/biz/alarmInfo/getDeviceType',
    method: 'get',
    params
  })
}

// 近三条设备告警
export function getCurrentAlarmList (params) {
  return request({
    url: '/biz/alarmInfo/getCurrentAlarmList',
    method: 'get',
    params
  })
}

// 能源使用情况
export function energyData (data) {
  return request({
    url: 'v1/water/home/trend/day',
    method: 'post',
    data
  })
}

// 查询当日用电数据
export function electricOfDay (params) {
  return request({
    url: 'v1/electric/trend/day',
    method: 'post',
    params
  })
}
// 查询当月用电数据
export function electricOfMonth (params) {
  return request({
    url: 'v1/electric/trend/month',
    method: 'post',
    params
  })
}

// 在线设备数
export function onlineDeviceNum (params) {
  return request({
    url: '/v1/device/info/online',
    method: 'get',
    params
  })
}
// 设备预警数
export function warningDeviceNum (params) {
  return request({
    url: '/biz/alarmInfo/getAlarmDeviceCount',
    method: 'get',
    params
  })
}

// 商业概览
export function shopScreen (params) {
  return request({
    url: '/shop/screen/data',
    method: 'get',
    params
  })
}
// 商铺类型
export function shopScreenNumber (params) {
  return request({
    url: '/shop/screen/number',
    method: 'get',
    params
  })
}

// 获取人流量车流量数据
export function peopleAndCar (params) {
  return request({
    url: '/parking/screen/data',
    method: 'get',
    params
  })
}

// 获取监控状态雷达数据
export function radarData (params) {
  return request({
    url: '/v1/device/category/list/iot',
    method: 'get',
    params
  })
}

// 停车数据
export function carData (params) {
  return request({
    url: '/v1/device/info/parking',
    method: 'get',
    params
  })
}

// 缴费通知获取
export function getNotice (params) {
  return request({
    url: '/iotCard/warn',
    method: 'get',
    params
  })
}

// 关闭通知
export function closeNotice (params) {
  return request({
    url: '/iotCard/cancelWarn',
    method: 'put',
    params
  })
}

export function turnoverAdd (params) {
  return request({
    url: '/opening/turnover/list/add',
    method: 'get',
    params
  })
}
